import type { ChatMessage, MessageFilePayload, MessageImagePayload, MessageVideoPayload } from 'models';
import { isMessageFilePayload, isMessageImagePayload, isMessageVideoPayload } from 'models';
import { useMemo } from 'react';

type MessageContent = {
  files: MessageFilePayload[];
  images: MessageImagePayload[];
  videos: MessageVideoPayload[];
};

export const useMessageContent = (message: Pick<ChatMessage, 'payload'>): MessageContent =>
  useMemo(
    () => ({
      files: message.payload.filter((payload) => isMessageFilePayload(payload)),
      images: message.payload.filter((payload) => isMessageImagePayload(payload)),
      videos: message.payload.filter((payload) => isMessageVideoPayload(payload)),
    }),
    [message.payload],
  );
